<template>
  <div>
    <vvs-control-wrapper
      v-if="label"
      :label="label"
      :description="description"
      classes="pull_left"
      :normal-label="normalLabel"
    ></vvs-control-wrapper>

    <select-city
      name="Şehir"
      label="Şehir"
      validate="required"
      v-model="address.city"
      @change="onChangeCity"
      :normal-label="normalLabel"
      return-object
    ></select-city>

    <select-county
      name="İlçe"
      label="İlçe"
      validate="required"
      :city="address.city"
      v-model="address.county"
      @change="onChangeCounty"
      :normal-label="normalLabel"
      return-object
    ></select-county>

  </div>
</template>

<script>
import SelectCity from './controls/SelectCity';
import SelectCounty from './controls/SelectCounty';

export default {
  name: 'VvsAddress',
  components: {
    SelectCity,
    SelectCounty,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    address: {
      type: Object,
    },
    normalLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChangeCity() {
      this.address.county = null;
      this.address.district = null;
      this.address.zipCode = null;
    },
    onChangeCounty() {
      this.address.district = null;
      this.address.zipCode = null;
    },
    onChangeDistrict() {
      const { id } = this.address.district || {};
      const zipCode = this.$store.getters['addresses/getZipCodeAsDistrict'](id);

      this.address.zipCode = zipCode;
    },
  },
};
</script>
